import { useUser } from '@hooks/user'
import { useQuery } from 'react-query'

import { fetchUserReports } from './fetchers'
import { UserReportHookBag } from './types'
import { useRouter } from 'next/router'

export function useUserReports(): UserReportHookBag {
  const { user } = useUser({ redirectOnUnauthorized: true })

  const userReports = useQuery(
    ['userReports', { userId: user.data?.id }],
    fetchUserReports,
    {
      enabled: typeof window !== 'undefined' && !!user.data?.id,
      refetchOnWindowFocus: false,
      refetchOnMount: false,
      retry: false
    }
  )

  return { userReports }
}
